'use strict';

var React = require('react');
var SpriteIconWeb = require('@swiggy-private/dls-web-food-icons/dist/SpriteIconWeb');
var SpriteIconWeb$1 = require('@swiggy-private/dls-web-icons/dist/SpriteIconWeb');
var Text = require('@swiggy-private/dls-web-core/dist/components/Text');
var jsUtils = require('@swiggy-private/js-utils');
var components_FoodItem_helpers_index = require('../../index-2bhV6eMA.js');
var Image = require('@swiggy-private/dls-web-core/dist/components/Image');
var styled = require('styled-components');
var PriceV4 = require('../../PriceV4-CAdVMHnO.js');
var OffertagV4 = require('../../OffertagV4-CLotnX1F.js');
var Rating = require('../../Rating-Dy9qwprD.js');
var ItemOverlay = require('../../ItemOverlay-C97dK9uZ.js');
var ScreenReaderOnly = require('../../ScreenReaderOnly-Bo2uWdwZ.js');
require('@swiggy-private/dls-web-core/dist/components/HalfCard');
require('@swiggy-private/dls-web-core/dist/components/Popup');
require('../../_tslib-D25eJ2i9.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const Container = styled__default.default.div(({ theme }) => ({
    padding: `${theme.spacing.xxSmall} 0`,
}));
const Content = styled__default.default.div(() => ({
    display: "flex",
    justifyContent: "space-between",
}));
const ItemName = styled__default.default(Text.Text) `
    word-break: break-word;
`;
const Description = styled__default.default(Text.Text)(({ theme, showMoreDescription, fullWidth, hasImage }) => (Object.assign(Object.assign({ marginTop: theme.spacing.small, wordBreak: "break-word" }, (!showMoreDescription && {
    wordBreak: "break-all",
    maxHeight: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    "-webkit-line-clamp": hasImage ? "3" : "2",
    "-webkit-box-orient": "vertical",
})), (fullWidth && {
    width: "50%",
}))));
const Flex = styled__default.default.div(({ showMoreDescription }) => (Object.assign({ display: "flex", alignItems: "end" }, (showMoreDescription && {
    cursor: "pointer",
}))));
const ItemPriceContainer = styled__default.default.div(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    marginTop: theme.spacing.xSmall,
}));
const MoreDetails = styled__default.default.button(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    padding: `${theme.spacing.xxSmall} ${theme.spacing.xSmall}`,
    borderRadius: theme.cornerRadius.halfRounded,
    border: `1px solid ${theme.colors[theme.colorMode].border_Secondary}`,
    width: "fit-content",
    marginTop: theme.spacing.small,
}));
const ImageContainer = styled__default.default.div(({ theme, customizable, isDweb }) => ({
    marginLeft: isDweb ? "60px" : theme.spacing.small,
    maxHeight: `${customizable ? "174px" : "164px"}`,
    minWidth: "156px",
}));
const ImageWrapper = styled__default.default.button(({ theme }) => ({
    width: "156px",
    height: "144px",
    borderRadius: theme.cornerRadius.small,
    padding: 0,
    overflow: "hidden",
    border: 0,
}));
const AddButtonWrapper = styled__default.default.div(({ theme, hasImage }) => ({
    position: "relative",
    left: "50%",
    bottom: "28px",
    top: `${hasImage ? undefined : theme.spacing.large}`,
    transform: "translateX(-50%)",
    zIndex: 1,
}));
const IconContainer = styled__default.default.div(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing.xxSmall,
}));
const GuiltFreeIcon = styled__default.default.div(({ theme }) => ({
    marginTop: theme.spacing.xSmall,
}));
const BestsellerIcon = styled__default.default.div(({ theme }) => ({
    marginLeft: theme.spacing.xxSmall,
    lineHeight: 0,
}));
const RightArrow = styled__default.default.div(({ theme }) => ({
    marginLeft: theme.spacing.xxSmall,
    marginBottom: "1px",
    "& svg": {
        height: "10px",
        width: "10px",
    },
}));
const ItemImage = styled__default.default(Image.Image)(({ theme }) => ({
    display: "flex",
    justifyContent: "space-between",
    objectFit: "cover",
    borderRadius: theme.cornerRadius.xSmall,
    position: "relative",
    "&:after": {
        position: "absolute",
        content: '""',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundBlendMode: "overlay",
        height: "144px",
        borderRadius: theme.cornerRadius.xSmall,
    },
}));
const ShowMoreDescription = styled__default.default(Text.Text)(({ theme }) => ({
    marginRight: theme.spacing.xSmall,
}));

const addButtonRenderer = (renderAddButtonProps) => {
    return typeof renderAddButtonProps == "function" ? renderAddButtonProps() : null;
};
function NormalItem({ imageId, imageUrl, name, description = "", renderAddButton, finalPrice, price, vegType, ribbon, position = 0, offerTags, specialCategoryTag, renderExtraComponents, itemExpandImpression = () => void 0, isDweb = false, customizable, bulletPoints, itemInfoTags, cartItemCount, ratings, isBestseller, isGuiltfree, showMoreDetailsCta = false, itemDetails, ingredients, backgroundColor, }) {
    var _a, _b;
    const buttonRef = React.useRef(null);
    const hasImage = !jsUtils.isEmpty(imageId) || !jsUtils.isEmpty(imageUrl);
    const [showOverlay, setShowOverlay] = React.useState(false);
    const [showMoreDescription, setShowMoreDescription] = React.useState(description.length < components_FoodItem_helpers_index.getDescriptionLength(hasImage, isDweb));
    const showDescription = React.useCallback(() => {
        if (!showMoreDescription) {
            setShowMoreDescription(true);
            itemExpandImpression === null || itemExpandImpression === void 0 ? void 0 : itemExpandImpression();
        }
    }, [itemExpandImpression, showMoreDescription]);
    const containerStyle = {
        background: components_FoodItem_helpers_index.COLOR_PALETTE[position % components_FoodItem_helpers_index.COLOR_PALETTE.length],
    };
    const hideOverlay = React.useCallback(() => setShowOverlay(false), []);
    const hideOverlayAndClick = React.useCallback((buttonType) => {
        var _a;
        hideOverlay();
        if (typeof document !== "undefined") {
            const buttonEle = (_a = buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current) === null || _a === void 0 ? void 0 : _a.querySelector(`.add-button-${buttonType}-container`);
            buttonEle === null || buttonEle === void 0 ? void 0 : buttonEle.click();
        }
    }, [hideOverlay]);
    const displayOverlay = React.useCallback(() => {
        setShowOverlay(true);
        itemExpandImpression === null || itemExpandImpression === void 0 ? void 0 : itemExpandImpression();
    }, [itemExpandImpression]);
    const showAddButton = (_hasImage) => {
        if (!renderAddButton)
            return null;
        return (React__default.default.createElement(AddButtonWrapper, { hasImage: _hasImage, ref: buttonRef }, addButtonRenderer(() => renderAddButton())));
    };
    const showAddButtonOverlay = (_hasImage) => {
        if (!renderAddButton)
            return null;
        return (React__default.default.createElement(AddButtonWrapper, { hasImage: _hasImage }, addButtonRenderer(() => renderAddButton(hideOverlayAndClick))));
    };
    const getOverlayHelperText = React.useMemo(() => `${components_FoodItem_helpers_index.OVERLAY_HELPER_TEXT} ${name}`, [name]);
    const normalItemLabel = React.useMemo(() => {
        return components_FoodItem_helpers_index.getNormalItemLabel({
            name,
            description,
            finalPrice,
            price,
            vegType,
            ribbon,
            offerTags,
            customizable,
            bulletPoints,
            itemInfoTags,
            specialCategoryTag,
        });
    }, [
        name,
        description,
        finalPrice,
        price,
        vegType,
        ribbon,
        offerTags,
        customizable,
        bulletPoints,
        itemInfoTags,
        specialCategoryTag,
    ]);
    return (React__default.default.createElement(Container, { "data-testid": "normal-dish-item" },
        React__default.default.createElement(Content, null,
            React__default.default.createElement(ScreenReaderOnly.ScreenReaderOnly, { text: normalItemLabel }),
            React__default.default.createElement("div", null,
                React__default.default.createElement(IconContainer, { "aria-hidden": true },
                    React__default.default.createElement(SpriteIconWeb.SpriteIconWeb, { iconName: vegType === 1 ? "vegVeg16" : "nonvegNonVeg16" }),
                    isBestseller && (React__default.default.createElement(BestsellerIcon, null,
                        React__default.default.createElement(SpriteIconWeb.SpriteIconWeb, { iconName: "bestseller16", width: "74" })))),
                React__default.default.createElement(ItemName, { color: "text_High_Emphasis", variant: "V2.body1.neutral.bold", "aria-hidden": "true" },
                    React__default.default.createElement(React__default.default.Fragment, null, name)),
                React__default.default.createElement(ItemPriceContainer, null,
                    React__default.default.createElement(PriceV4.PriceV4, { price: price, finalPrice: finalPrice }),
                    React__default.default.createElement(OffertagV4.OfferTagV4, { offers: offerTags })),
                !jsUtils.isEmpty(ratings) && !jsUtils.isEmpty(ratings === null || ratings === void 0 ? void 0 : ratings.aggregatedRating) && (React__default.default.createElement(Rating.Ratings, { rating: ((_a = ratings === null || ratings === void 0 ? void 0 : ratings.aggregatedRating) === null || _a === void 0 ? void 0 : _a.rating) || "", ratingCount: ((_b = ratings === null || ratings === void 0 ? void 0 : ratings.aggregatedRating) === null || _b === void 0 ? void 0 : _b.ratingCountV2) || "" })),
                isGuiltfree && (React__default.default.createElement(GuiltFreeIcon, null,
                    React__default.default.createElement(SpriteIconWeb.SpriteIconWeb, { iconName: "guiltfree24", width: "61" }))),
                showMoreDetailsCta ? (React__default.default.createElement(React__default.default.Fragment, null, !jsUtils.isEmpty(description) && (React__default.default.createElement(MoreDetails, { onClick: displayOverlay },
                    React__default.default.createElement(Text.Text, { color: "text_Med_Emphasis", variant: "V2.body3.neutral.medium" }, components_FoodItem_helpers_index.TEXTS.MORE_DETAILS),
                    React__default.default.createElement(RightArrow, null,
                        React__default.default.createElement(SpriteIconWeb$1.SpriteIconWeb, { iconName: "chevronRight12", fillColor: "text_Med_Emphasis" })))))) : (React__default.default.createElement(React__default.default.Fragment, null, !jsUtils.isEmpty(description) && hasImage && (React__default.default.createElement(Flex, { onClick: showDescription, showMoreDescription: showMoreDescription },
                    React__default.default.createElement(Description, { "aria-hidden": true, showMoreDescription: showMoreDescription, color: "text_Med_Emphasis", variant: "V2.body3.neutral.regular", hasImage: hasImage }, description),
                    !showMoreDescription && (React__default.default.createElement(Text.Text, { color: "text_Med_Emphasis", variant: "V2.body3.neutral.bold", style: { marginRight: "8px" } }, components_FoodItem_helpers_index.DESC_EXP_TEXT)))))),
                !jsUtils.isEmpty(renderExtraComponents) && (renderExtraComponents === null || renderExtraComponents === void 0 ? void 0 : renderExtraComponents())),
            React__default.default.createElement(ImageContainer, { "aria-hidden": true, customizable: customizable, isDweb: isDweb },
                hasImage && (React__default.default.createElement(ImageWrapper, { style: containerStyle, onClick: displayOverlay, "aria-label": getOverlayHelperText },
                    React__default.default.createElement(ItemImage, { src: imageUrl, cloudinaryId: imageUrl || imageId, width: "156", height: "144", alt: name }))),
                React__default.default.createElement(ItemOverlay.ItemOverlayV4, { item: name, description: description, price: price, finalPrice: finalPrice, ratings: ratings, isGuiltfree: isGuiltfree, offerTags: offerTags, isBestseller: isBestseller, imageId: imageId, imageUrl: jsUtils.getCloudinaryUrl(imageId || "", {
                        fit: true,
                        height: components_FoodItem_helpers_index.OVERLAY_IMAGE_SIZE,
                        width: components_FoodItem_helpers_index.OVERLAY_IMAGE_SIZE,
                    }), addButtonRenderer: showAddButtonOverlay, vegType: vegType, showOverlay: showOverlay, afterClose: hideOverlay, fallbackBackground: containerStyle, isDweb: isDweb, itemDetails: itemDetails, ingredients: ingredients, backgroundColor: backgroundColor }),
                showAddButton(hasImage))),
        React__default.default.createElement(React__default.default.Fragment, null, !jsUtils.isEmpty(description) && !hasImage && !showMoreDetailsCta && (React__default.default.createElement(Flex, { onClick: showDescription },
            React__default.default.createElement(Description, { "aria-hidden": true, fullWidth: true, showMoreDescription: showMoreDescription, color: "text_Med_Emphasis", variant: "V2.body3.neutral.regular", hasImage: hasImage }, description),
            !showMoreDescription && (React__default.default.createElement(ShowMoreDescription, { color: "text_Med_Emphasis", variant: "V2.body3.neutral.medium" }, components_FoodItem_helpers_index.DESC_EXP_TEXT))))),
        cartItemCount != undefined && cartItemCount > 0 && (React__default.default.createElement(ScreenReaderOnly.ScreenReaderOnly, { text: components_FoodItem_helpers_index.ACCESSIBILITY_TEXTS.SKIP_TO_VIEW_CART_BTN, as: "a", href: "#view-cart-btn" }))));
}
var FoodItem = React.memo(NormalItem);

exports.FoodItem = FoodItem;
//# sourceMappingURL=index.js.map
